import SiteLayout from './SiteLayout';
import SEO from '../../components/layout/SEO';
import { useCopy } from '../../content';
import { useShopConfig } from '../../hooks/useShopConfig';

/** Services page — content pass §3. All 13 rendered from config. */
export default function ServicesPage() {
  const copy = useCopy();
  const c = copy.services;
  const { t, serviceName, shop, services, addOns, formatDuration } = useShopConfig();

  return (
    <SiteLayout>
      <SEO title={t(c.hero.headline)} description={t(c.hero.subline)} />

      <section className="max-w-4xl mx-auto px-6 pt-16 pb-10">
        <p className="kd-kicker text-gold-text text-xs uppercase tracking-[0.18em]">{t(c.hero.kicker)}</p>
        <h1 className="font-serif text-navy text-4xl md:text-5xl mt-4">{t(c.hero.headline)}</h1>
        <p className="text-slate-body text-lg mt-4">{t(c.hero.subline)}</p>
      </section>

      <section className="max-w-6xl mx-auto px-6 pb-12">
        <h2 className="font-serif text-navy text-3xl">{t(c.haircuts.headline)}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
          {services.map((s) => (
            <article key={s.slug} className="bg-paper border border-edge-2 rounded-card p-6 flex flex-col">
              {'featured' in s && s.featured && <span aria-hidden className="text-gold">⭐</span>}
              <h3 className="font-serif text-navy text-xl">{serviceName(s)}</h3>
              <p className="font-sans text-slate-body text-sm mt-1">
                {s.price_display} · {formatDuration(s.duration_min)}
              </p>
              <p className="text-slate-body text-sm mt-3 leading-relaxed flex-1">
                {t(c.descriptions[s.slug]?.description ?? '')}
              </p>
              <a href={shop.bookingUrl} target="_blank" rel="noopener noreferrer" className="mt-5 text-navy font-serif underline underline-offset-4">
                {t(c.bookThis)}
              </a>
            </article>
          ))}
        </div>
      </section>

      <section className="bg-paper border-y border-edge-1">
        <div className="max-w-6xl mx-auto px-6 py-14">
          <h2 className="font-serif text-navy text-3xl">{t(c.addOns.headline)}</h2>
          <p className="text-slate-body mt-2 max-w-2xl">{t(c.addOns.intro)}</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
            {addOns.map((a) => (
              <article key={a.slug} className="bg-page border border-edge-2 rounded-card p-5">
                <h3 className="font-serif text-navy">{serviceName(a)}</h3>
                <p className="font-sans text-slate-body text-sm mt-1">
                  {a.price_display} · +{a.duration_min} min
                </p>
                <p className="text-slate-body text-sm mt-2 leading-relaxed">
                  {t(c.descriptions[a.slug]?.description ?? '')}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-16 text-center">
        <h2 className="font-serif text-navy text-3xl">{t(c.cta.headline)}</h2>
        <p className="text-slate-body mt-3">{t(c.cta.body)}</p>
        {/* Single CTA — the walk-in line is joined at the in-shop tablet. */}
        <div className="mt-8 flex justify-center">
          <a href={shop.bookingUrl} target="_blank" rel="noopener noreferrer" className="bg-navy text-cream px-7 py-3 rounded-pill font-serif shadow-shell">
            {t(c.cta.ctaBook)}
          </a>
        </div>
      </section>
    </SiteLayout>
  );
}
